module.exports = __webpack_public_path__ + "static/media/tools-h5p-2.0ceb7155.svg";